export function canInstantImageLoad(untilIndex: number, index: number) {
  return untilIndex - 1 >= index;
}
